import { render, staticRenderFns } from "./AdminOversattningar.vue?vue&type=template&id=c7261634&scoped=true"
import script from "./AdminOversattningar.vue?vue&type=script&lang=js"
export * from "./AdminOversattningar.vue?vue&type=script&lang=js"
import style0 from "./AdminOversattningar.vue?vue&type=style&index=0&id=c7261634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7261634",
  null
  
)

export default component.exports